import { render, staticRenderFns } from "./IflbTable.vue?vue&type=template&id=7f8324b0"
import script from "./IflbTable.vue?vue&type=script&lang=js"
export * from "./IflbTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports